import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table;
const ClientInductionList = ({
  data,
  handleSort,
  getAllinvitedData,
  expandedRows = [],
  toggleRowExpansion,
  buildRowKey,
  rowWorkersState = {},
}) => {
  const formatDate = (value) =>
    value ? moment(value).format("DD/MM/YYYY") : "-";

  const resolveStatusBadge = (status) => {
    switch ((status || "").toLowerCase()) {
      case "active":
      case "completed":
      case "approved":
      case "compliant":
        return "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium";
      case "draft":
      case "in progress":
        return "badge bg-blue-50 text-blue-800 py-0.5 px-2 rounded-lg font-normal";
      case "archived":
      case "deactivated":
      case "not inducted":
        return "badge text-gray-700 bg-gray-100 py-0.5 px-2 rounded-lg font-normal";
      case "expired":
      case "not approved":
      case "Non-Compliant":
        return "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium";
      default:
        return "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium";
    }
  };

  const renderWorkerRows = (rowKey) => {
    const { data: workers = [], status, error } = rowWorkersState[rowKey] || {};

    if (status === "loading") {
      return <p className="text-sm text-gray-500">Loading workers…</p>;
    }

    if (status === "error") {
      return (
        <p className="text-sm text-error-600">
          {error || "Unable to load workers for this induction."}
        </p>
      );
    }

    if (!workers.length) {
      return <p className="text-sm text-gray-500">No workers found for this induction.</p>;
    }

    return (
      <div className="border border-gray-200 rounded-lg bg-white shadow-sm overflow-x-auto">
        <div className="md:min-w-[1100px]">
          <div className="hidden md:grid grid-cols-[0.8fr_2fr_1.2fr_1.2fr_1.5fr_1fr_1fr] items-center pl-8 pr-4 py-2 border-b border-gray-200 bg-gray-50 text-xs font-semibold text-gray-500 tracking-wide">
          <span>Worker ID</span>
          <span>Worker</span>
          <span>Worker Status</span>
          <span>Induction Status</span>
          <span>Occupation</span>
          <span className="text-center">Date completed</span>
          <span className="text-center">Expiry date</span>
        </div>
        {workers.map((worker, workerIndex) => {
          const workerStatus = worker?.worker_status || "Deactivated";
          const inductionStatus = worker?.induction_status || "Not inducted";
          const expiryDate = (worker?.completion_date && worker?.valid_days)
             ? moment(worker.completion_date).add(worker.valid_days, 'days')
             : null;
          
          const getDisplayWorkerId = (worker) => {
            const id = worker?.employee_id || worker?.individual_id || worker?.worker_id;
            if (!id) return "-";
            const idStr = String(id).toUpperCase();
            if (idStr.startsWith("E-")) return id;
            if (idStr.startsWith("E")) return `E-${idStr.substring(1)}`;
            return `E-${id}`;
          };
          
          return (
            <div
              key={`${rowKey}-worker-${worker?.worker_id || workerIndex}`}
              className="pl-8 pr-4 py-4 border-t border-gray-100 first:border-t-0"
            >
              <div className="md:grid md:grid-cols-[0.8fr_2fr_1.2fr_1.2fr_1.5fr_1fr_1fr] md:items-center md:gap-4">
                <div className="hidden md:block text-sm font-medium text-gray-900">
                  {getDisplayWorkerId(worker)}
                </div>
                <div className="flex flex-wrap items-center gap-3 mb-3 md:mb-0">
                  <h4 className="text-sm font-semibold text-gray-900">
                    {worker?.worker_name || worker?.name || "Worker"}
                  </h4>
                </div>
                <div className="hidden md:block text-sm font-medium">
                  <span className={resolveStatusBadge(workerStatus)}>
                    {workerStatus
                      ? workerStatus.charAt(0).toUpperCase() + workerStatus.slice(1)
                      : "Unknown"}
                  </span>
                </div>
                <div className="hidden md:block text-sm font-medium">
                  <span className={resolveStatusBadge(inductionStatus)}>
                    {inductionStatus
                      ? inductionStatus.charAt(0).toUpperCase() + inductionStatus.slice(1)
                      : "Unknown"}
                  </span>
                </div>
                <div className="hidden md:block text-sm font-medium text-gray-900">
                  {worker?.occupation || "-"}
                </div>
                <div className="hidden md:block text-sm font-medium text-gray-900 text-center">
                  {formatDate(worker?.completion_date)}
                </div>
                <div className="hidden md:block text-sm font-medium text-gray-900 text-center">
                  {formatDate(expiryDate)}
                </div>
              </div>

              <div className="mt-3 grid grid-cols-2 gap-4 text-xs text-gray-600 md:hidden">
                <div>
                  <span className="block text-gray-500">Worker Status</span>
                  <span className={resolveStatusBadge(workerStatus)}>
                    {workerStatus
                      ? workerStatus.charAt(0).toUpperCase() + workerStatus.slice(1)
                      : "Unknown"}
                  </span>
                </div>
                <div>
                  <span className="block text-gray-500">Induction Status</span>
                  <span className={resolveStatusBadge(inductionStatus)}>
                    {inductionStatus
                      ? inductionStatus.charAt(0).toUpperCase() + inductionStatus.slice(1)
                      : "Unknown"}
                  </span>
                </div>
                <div>
                  <span className="block text-gray-500">Worker ID</span>
                  <span className="font-medium text-gray-900">{getDisplayWorkerId(worker)}</span>
                </div>
                <div>
                  <span className="block text-gray-500">Occupation</span>
                  <span className="font-medium text-gray-900">{worker?.occupation || "-"}</span>
                </div>
                <div>
                  <span className="block text-gray-500">Date completed</span>
                  <span className="font-medium text-gray-900">
                    {formatDate(worker?.completion_date)}
                  </span>
                </div>
                <div>
                  <span className="block text-gray-500">Expiry date</span>
                  <span className="font-medium text-gray-900">
                    {formatDate(expiryDate)}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th>
                <span className="flex items-center gap-1">Client name</span>
              </Th>
              <Th>Provider</Th>
              <Th>Induction name</Th>
              <Th>Workers assigned</Th>
              <Th>Site </Th>
              <Th>Status</Th>
              <Th>Modules</Th>
              <Th>Valid days</Th>
              <Th>Completion rate</Th>
              <Th onClick={(e) => handleSort(e, "publish_date")}>
                <span className="flex items-center gap-1">
                  Publish date
                  <svg
                    className={`transform ${getAllinvitedData.sort === "publish_date" &&
                        getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
            </Tr>
          </THead>
          <TBody>
            {data?.inductionReport?.length > 0 &&
              data?.inductionReport?.map((item, index) => {
                const rowKey = buildRowKey ? buildRowKey(item, index) : index;
                const isExpanded = expandedRows?.includes(rowKey);
                const workerState = rowWorkersState[rowKey] || {};
                const workerCount = Number(
                  item?.worker_assigned ??
                    item?.workers_assigned ??
                    item?.workers_count ??
                    item?.total_workers ??
                    0
                );
                const canExpand = Number.isFinite(workerCount) && workerCount > 0;


                const handleRowToggle = () => {
                  if (!canExpand) {
                    return;
                  }

                  if (typeof toggleRowExpansion === "function") {
                    toggleRowExpansion(rowKey, item);
                  }
                };

                return (
                  <React.Fragment key={rowKey}>
                    <Tr className="align-top">
                      <Td className="w-48">
                        <div className="flex items-center gap-2">
                          {canExpand ? (
                            <button
                              type="button"
                              onClick={handleRowToggle}
                              className="flex items-center justify-center p-1 text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500/40 rounded"
                              aria-expanded={isExpanded}
                              aria-label={`${isExpanded ? "Collapse" : "Expand"} worker details`}
                            >
                              <svg
                                className={`transition-transform duration-200 ${isExpanded ? "rotate-180" : ""}`}
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3 4.5L6 7.5L9 4.5"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          ) : (
                            <span className="inline-flex w-6" aria-hidden="true" />
                          )}
                          <span>{item?.client_name}</span>
                        </div>
                      </Td>
                    <Td>{item?.provider_name}</Td>

                    <Td>
                      {(item?.company_ind_name != null
                        ? item?.company_ind_name
                        : item?.site_ind_name) || "-"}
                    </Td>
                    <Td>{item?.worker_assigned || "-"}</Td>
                    <Td>
                      {item?.site_name != null ? item?.site_name : "Company"}
                    </Td>
                    <Td>
                      <span
                        className={
                          item?.status === 'active'
                            ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium"
                            : item?.status === 'draft'
                              ? "badge bg-blue-50 text-blue-800 py-0.5 px-2 rounded-lg font-normal"
                              : item?.status === 'archived'
                                ? "badge text-gray-700 bg-gray-100 py-0.5 px-2 rounded-lg font-normal"
                                : "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium" // fallback
                        }
                        // in this add 
                      >
                        {item?.status?.charAt(0).toUpperCase() + item?.status?.slice(1)}
                      </span>
                    </Td>

                    <Td>{item?.modules_count || 0}</Td>
                    <Td>{item?.valid_days || 0}</Td>
                    <Td className={"flex items-center gap-1	"}>
                      <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                        <div
                          className="bg-blue-600 h-2.5 rounded-full"
                          style={{
                            width: `${Number(item?.completion_rate)?.toFixed(
                              2
                            )}%`,
                          }}
                        ></div>
                      </div>
                      {`${Number(item?.completion_rate)?.toFixed(2)}%`}
                    </Td>
                    <Td>
                      {formatDate(item?.publish_date)}
                    </Td>
                    </Tr>
                    {canExpand && isExpanded && (
                      <Tr className="bg-gray-50">
                        <Td colSpan={11} className="p-4">
                          <div className="space-y-3">
                            <h4 className="text-sm font-semibold text-gray-900">
                              Workers assigned ({workerState?.data?.length ?? 0})
                            </h4>
                            {renderWorkerRows(rowKey)}
                          </div>
                        </Td>
                      </Tr>
                    )}
                  </React.Fragment>
                );
              })}

          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};
export default ClientInductionList;
